import { Component, Input, OnInit, OnDestroy, ElementRef, EventEmitter, Output } from '@angular/core';
import { ModalService, Project, ProjectManagerService } from '@ops/shared-types';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { switchMap } from 'rxjs';

@Component({
  selector: 'ops-duplicate-project-modal',
  templateUrl: './duplicate-project-modal.component.html',
  styleUrls: ['./duplicate-project-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
})
export class DuplicateProjectModalComponent implements OnInit, OnDestroy {
  @Input() id: string;

  @Output() projectDuplicated: EventEmitter<{projectId: string, projectToInsert: Project}> = new EventEmitter<{projectId: string, projectToInsert: Project}>();
  
  private element: any;
  project: Project;

  projectCode = '';
  deliverables = false;
  departments = false;
  productionCost = false;

  constructor(
    private modalService: ModalService, 
    private el: ElementRef,
    private pm: ProjectManagerService
  ) {
    this.element = this.el.nativeElement;
  }

  ngOnInit(): void {
    if (!this.id) {
      console.error('modal must have an id');
      return;
    }
    this.element.style.display = 'none';
    document.body.appendChild(this.element);
    this.element.addEventListener('click', (event: MouseEvent) => {
      if ((event.target as HTMLElement).className === 'info-modal') {
        this.close();
      }
    });
    this.modalService.add(this);
  }

  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.element.remove();
  }

  open(project: Project): void {
    this.project = project;
    this.element.style.opacity = '0';
    this.element.style.display = 'flex';
    // Force reflow
    void this.element.offsetHeight;
    this.element.style.opacity = '1';
    document.body.classList.add('info-modal-open');
  }

  close(): void {
    this.element.style.display = 'none';
    document.body.classList.remove('info-modal-open');
    this.resetValues();
  }

  onDuplicate(): void {
    this.pm.duplicateProject(
      this.project, 
      this.projectCode, 
      this.deliverables, 
      this.departments, 
      this.productionCost).pipe(
        switchMap((projectIds: string) => {
        return this.pm.getProjectById(JSON.parse(projectIds)[0]);
      })).subscribe((project: Project) => {
        this.projectDuplicated.emit({projectId: this.project._id, projectToInsert: project});
        this.close();
      });
  };

  private resetValues(): void {
    this.projectCode = '';
    this.deliverables = false;
    this.departments = false;
    this.productionCost = false;
  }
}
